export default {
    eta_destination: "Destino",
    eta_start: "Inicio",
    eta_end: "Fin",
    eta_copyLink: "Copiar Enlace",
    eta_copied: "Copiado"
}